module.exports = __webpack_public_path__ + "img/icon.f300b258.png";